module.exports = __webpack_public_path__ + "static/media/face1.f814797f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/face1.svg
// module id = 971
// module chunks = 0